import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Form, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '@core/services/common.service';
import { PolicyService } from '@core/services/policy.service';
import { Agent } from '@shared/models/agent';
import { UserRole } from '@shared/models/codebooks/user-role';
import { MaInsurance } from '@shared/models/ma-insurance';
import { MaInsuranceUpdate } from '@shared/models/ma-insurance-update';
import { Policy } from '@shared/models/policy';
import { User } from '@shared/models/user';

@Component({
    selector: 'app-ma-insurance',
    templateUrl: './ma-insurance.component.html',
    styleUrls: ['./ma-insurance.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MaInsuranceComponent {
    @Input() agentSource: number;
    @Input() policy: Policy;
    @Input() maInsurance: MaInsurance;
    @Input() showEdit: boolean;
    @Input() agents: Array<Agent> = [];

    public editMode: boolean = false;

    public loggedUser: User;
    public readonly role = UserRole;

    private _showSection = false;
    private _disabledForType = ['HOME-INSURANCE'];

    constructor(
        private commonService: CommonService
    ) {
        this.loggedUser = this.commonService.getLoggedUser();
    }

    get agentForLife(): Agent | null {
        return this.agents && this.agents[0] ? this.agents[0] : null;
    }

    get showSection(): boolean {
        return this.maInsurance !== null && !this._disabledForType.includes(this.maInsurance.detailTypeIdentifier);
    }
}
